import basic from '@com/lang/en/basic'
import resourceManager from '@com/lang/en/resourceManager'
import workbench from '@com/lang/en/workbench'
import locale from './locales/en.json'
import exportHistory from '@pt/lang/en/exportHistory'
import whole from '@pt/lang/en/whole'
import videoProject from '@pt/lang/en/videoProject'
import assetLibrary from '@pt/lang/en/assetLibrary'
import taskCenter from '@pt/lang/en/taskCenter'
import cropperDialog from '@/lang/en/cropperDialog'
import playableProject from '@pt/lang/en/playableProject'
import templateLibrary from '@pt/lang/en/templateLibrary'
import dashboard from '@pt/lang/en/dashboard'
import home from '@pt/lang/en/home'
import login from '@pt/lang/en/login'
import voiceLab from '@pt/lang/en/voiceLab'

export default {
  basic,
  resourceManager,
  cropperDialog,
  workbench: {
    ...workbench,
  },
  playTurbo: {
    exportHistory,
    videoProject,
    assetLibrary,
    whole,
    taskCenter,
    playableProject,
    templateLibrary,
    dashboard,
    home,
    login,
    voiceLab,
  },
  ...locale,
}
